module.exports = __webpack_public_path__ + "img/dew.fd3fdc14.svg";